import { Stack } from '@mantine/core';
import { ControlledOptionsSwitcher } from '@/app/components/shared/navigation/OptionsSwitcher';
import { SettingTitle } from '../../../components/SettingTitle';
import { useFormContext } from '../../../contexts/formContext';

const path = 'assetSimplification.topologySettings.meshDensityEqualization';

export function PolygonDistributionMethod() {
  const form = useFormContext();
  return (
    <Stack gap='xs'>
      <SettingTitle
        title='Polygon Distribution Method'
        description='Choose between feature-aware, adaptive mesh simplification (standard)
        and, alternatively, equalized polygon distribution.'
      />
      <ControlledOptionsSwitcher
        options={[
          { label: 'Adaptive', value: 0 },
          { label: 'Equalized', value: 1 },
        ]}
        onChanged={(option) => form.setFieldValue(path, option)}
        value={form.values.assetSimplification?.topologySettings.meshDensityEqualization}
      />
    </Stack>
  );
}
